import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/app/shell/page-header";
import { guardRoute } from "@/lib/policy/route-guard";
import { PlatformFormRequestsCard } from "./-components/platform-form-requests-card";

export const Route = createFileRoute("/_authenticated/platform_/form-requests")({
  beforeLoad: ({ context }) => guardRoute(context.me, "platform-form-requests"),
  component: PlatformFormRequests,
});

/** Forms buildings have asked us for. */
function PlatformFormRequests() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Form requests"
        meta="Forms buildings asked for. Marking one available emails whoever asked."
      />
      <PlatformFormRequestsCard />
    </div>
  );
}
